var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_162_6935)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.24H24V18.48H18V12.24Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.24H34V18.48H28V12.24Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.24H44V18.48H38V12.24Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.24H113V18.48H58V12.24Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 103,
    width: 120,
    height: 18,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 128,
    width: 122,
    height: 22,
    rx: 4,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7539 137.801H60.043C60.0117 137.579 59.9479 137.383 59.8516 137.211C59.7552 137.036 59.6315 136.888 59.4805 136.766C59.3294 136.643 59.1549 136.549 58.957 136.484C58.7617 136.419 58.5495 136.387 58.3203 136.387C57.9063 136.387 57.5456 136.49 57.2383 136.695C56.931 136.898 56.6927 137.195 56.5234 137.586C56.3542 137.974 56.2695 138.445 56.2695 139C56.2695 139.57 56.3542 140.049 56.5234 140.437C56.6953 140.826 56.9349 141.118 57.2422 141.316C57.5495 141.514 57.9049 141.613 58.3086 141.613C58.5352 141.613 58.7448 141.583 58.9375 141.523C59.1328 141.464 59.306 141.376 59.457 141.262C59.6081 141.145 59.7331 141.003 59.832 140.836C59.9336 140.669 60.0039 140.479 60.043 140.266L61.7539 140.273C61.7096 140.641 61.599 140.995 61.4219 141.336C61.2474 141.674 61.0117 141.978 60.7148 142.246C60.4206 142.512 60.069 142.723 59.6602 142.879C59.2539 143.033 58.7943 143.109 58.2813 143.109C57.5677 143.109 56.9297 142.948 56.3672 142.625C55.8073 142.302 55.3646 141.835 55.0391 141.223C54.7161 140.611 54.5547 139.87 54.5547 139C54.5547 138.128 54.7188 137.385 55.0469 136.773C55.375 136.161 55.8203 135.695 56.3828 135.375C56.9453 135.052 57.5781 134.891 58.2813 134.891C58.7448 134.891 59.1745 134.956 59.5703 135.086C59.9688 135.216 60.3216 135.406 60.6289 135.656C60.9362 135.904 61.1862 136.207 61.3789 136.566C61.5742 136.926 61.6992 137.337 61.7539 137.801ZM64.1953 143H62.3828L65.1445 135H67.3242L70.082 143H68.2695L66.2656 136.828H66.2031L64.1953 143ZM64.082 139.855H68.3633V141.176H64.082V139.855ZM73.8809 143H71.0449V135H73.9043C74.709 135 75.4017 135.16 75.9824 135.48C76.5632 135.798 77.0098 136.255 77.3223 136.852C77.6374 137.448 77.7949 138.161 77.7949 138.992C77.7949 139.826 77.6374 140.542 77.3223 141.141C77.0098 141.74 76.5605 142.199 75.9746 142.52C75.3913 142.84 74.6934 143 73.8809 143ZM72.7363 141.551H73.8105C74.3105 141.551 74.7311 141.462 75.0723 141.285C75.416 141.105 75.6738 140.828 75.8457 140.453C76.0202 140.076 76.1074 139.589 76.1074 138.992C76.1074 138.401 76.0202 137.918 75.8457 137.543C75.6738 137.168 75.4173 136.892 75.0762 136.715C74.735 136.538 74.3145 136.449 73.8145 136.449H72.7363V141.551ZM79.9756 143H78.1631L80.9248 135H83.1045L85.8623 143H84.0498L82.0459 136.828H81.9834L79.9756 143ZM79.8623 139.855H84.1436V141.176H79.8623V139.855ZM90.9824 137.301C90.9512 136.986 90.8171 136.741 90.5801 136.566C90.3431 136.392 90.0215 136.305 89.6152 136.305C89.3392 136.305 89.1061 136.344 88.916 136.422C88.7259 136.497 88.5801 136.603 88.4785 136.738C88.3796 136.874 88.3301 137.027 88.3301 137.199C88.3249 137.342 88.3548 137.467 88.4199 137.574C88.4876 137.681 88.5801 137.773 88.6973 137.852C88.8145 137.927 88.9499 137.993 89.1035 138.051C89.2572 138.105 89.4212 138.152 89.5957 138.191L90.3145 138.363C90.6634 138.441 90.9837 138.546 91.2754 138.676C91.5671 138.806 91.8197 138.966 92.0332 139.156C92.2467 139.346 92.4121 139.57 92.5293 139.828C92.6491 140.086 92.7103 140.382 92.7129 140.715C92.7103 141.204 92.5853 141.629 92.3379 141.988C92.0931 142.345 91.7389 142.622 91.2754 142.82C90.8145 143.016 90.2585 143.113 89.6074 143.113C88.9616 143.113 88.3991 143.014 87.9199 142.816C87.4434 142.618 87.071 142.326 86.8027 141.937C86.5371 141.547 86.3978 141.064 86.3848 140.488H88.0215C88.0397 140.757 88.1165 140.98 88.252 141.16C88.39 141.337 88.5736 141.471 88.8027 141.562C89.0345 141.651 89.2962 141.695 89.5879 141.695C89.8743 141.695 90.123 141.654 90.334 141.57C90.5475 141.487 90.7129 141.371 90.8301 141.223C90.9473 141.074 91.0059 140.904 91.0059 140.711C91.0059 140.531 90.9525 140.38 90.8457 140.258C90.7415 140.135 90.5879 140.031 90.3848 139.945C90.1842 139.859 89.9382 139.781 89.6465 139.711L88.7754 139.492C88.1009 139.328 87.5684 139.072 87.1777 138.723C86.7871 138.374 86.5931 137.904 86.5957 137.312C86.5931 136.828 86.722 136.405 86.9824 136.043C87.2454 135.681 87.6061 135.398 88.0645 135.195C88.5228 134.992 89.0436 134.891 89.627 134.891C90.2207 134.891 90.7389 134.992 91.1816 135.195C91.627 135.398 91.9733 135.681 92.2207 136.043C92.4681 136.405 92.5957 136.824 92.6035 137.301H90.9824ZM93.5459 136.395V135H100.116V136.395H97.667V143H95.9951V136.395H93.5459ZM101.198 143V135H104.354C104.959 135 105.474 135.108 105.901 135.324C106.331 135.538 106.658 135.841 106.882 136.234C107.108 136.625 107.222 137.085 107.222 137.613C107.222 138.145 107.107 138.602 106.878 138.984C106.649 139.365 106.317 139.656 105.882 139.859C105.45 140.062 104.926 140.164 104.312 140.164H102.198V138.805H104.038C104.361 138.805 104.629 138.76 104.843 138.672C105.056 138.583 105.215 138.451 105.319 138.273C105.426 138.096 105.479 137.876 105.479 137.613C105.479 137.348 105.426 137.124 105.319 136.941C105.215 136.759 105.055 136.621 104.839 136.527C104.625 136.431 104.356 136.383 104.03 136.383H102.89V143H101.198ZM105.519 139.359L107.507 143H105.64L103.694 139.359H105.519ZM109.796 143H107.983L110.745 135H112.925L115.683 143H113.87L111.866 136.828H111.804L109.796 143ZM109.683 139.855H113.964V141.176H109.683V139.855ZM116.646 143V135H119.802C120.406 135 120.922 135.108 121.349 135.324C121.778 135.538 122.105 135.841 122.329 136.234C122.556 136.625 122.669 137.085 122.669 137.613C122.669 138.145 122.554 138.602 122.325 138.984C122.096 139.365 121.764 139.656 121.329 139.859C120.897 140.062 120.373 140.164 119.759 140.164H117.646V138.805H119.485C119.808 138.805 120.076 138.76 120.29 138.672C120.504 138.583 120.662 138.451 120.767 138.273C120.873 138.096 120.927 137.876 120.927 137.613C120.927 137.348 120.873 137.124 120.767 136.941C120.662 136.759 120.502 136.621 120.286 136.527C120.073 136.431 119.803 136.383 119.478 136.383H118.337V143H116.646ZM120.966 139.359L122.954 143H121.087L119.142 139.359H120.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 42,
    width: 49,
    height: 48,
    rx: 4,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 38,
    width: 49,
    height: 48,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.075 66.6919L117.629 62.3922C116.733 61.2743 114.987 61.4333 114.308 62.6946L108.588 73.3148C107.87 74.6473 108.835 76.2632 110.349 76.2632H140.622C142.142 76.2632 143.106 74.6342 142.375 73.3013L133.012 56.2322C132.237 54.8196 130.195 54.8563 129.471 56.2959L124.423 66.3393C123.768 67.6411 121.986 67.8287 121.075 66.6919Z",
    fill: "white",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.194,
    cy: 52.8947,
    r: 2.89474,
    fill: "white",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 52,
    width: 57,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 65,
    width: 57,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 78,
    width: 31.3033,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37,
    width: 57,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 164,
    width: 122,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 177,
    width: 122,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 190,
    width: 67,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_162_6935",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_162_6935"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_6935"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_6935",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageLead);
export default __webpack_public_path__ + "static/media/canvas_page_lead.5259935808624c9a5834680fc1207d7e.svg";
export { ForwardRef as ReactComponent };